
import Vue from 'vue';
import { Component, Model, Prop } from 'vue-property-decorator'
import _ from 'lodash';

@Component
export default class AppRadioInput extends Vue {
    @Model('change') modelValue!: string|object;
    @Prop() value!: string|object;
    @Prop() label!: string;
    @Prop({default: null})  error!: string | null;

    onSelect() {
        this.$emit('change', this.value);
    }
};
